var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('validation-observer', {
    ref: "form"
  }, [_c('b-alert', {
    staticClass: "mb-2",
    attrs: {
      "show": "",
      "variant": "primary"
    }
  }, [_c('strong', [_vm._v("Cara penempatan aset:")]), _vm._v(" (1) Pilih no. pengadaan → (2) Klik baris aset di kiri → (3) Isi lokasi → (4) Klik "), _c('em', [_vm._v("Tambah ke antrian")]), _vm._v(" (bisa berulang) → (5) Klik "), _c('em', [_vm._v("Simpan penempatan")]), _vm._v(". ")]), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [!_vm.isInvoiceAvailable ? _c('b-form-group', {
    attrs: {
      "label": "Pilih No. Pengadaan"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.pengadaans,
      "label": "text",
      "placeholder": "Cari / pilih pengadaan..."
    },
    model: {
      value: _vm.selectedInvoice,
      callback: function callback($$v) {
        _vm.selectedInvoice = $$v;
      },
      expression: "selectedInvoice"
    }
  })], 1) : _c('div', [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("Pengadaan")]), _c('strong', [_vm._v("ID " + _vm._s(_vm.pengadaan.id) + " — No. Pengadaan: " + _vm._s(_vm.pengadaan.no))])])], 1), _c('b-col', {
    staticClass: "d-flex align-items-end justify-content-md-end",
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$router.push("/asset-penyimpanan/add-empty");
      }
    }
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah Penyimpanan Kosong ")], 1)])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Aset dari pengadaan")]), _c('p', {
    staticClass: "text-muted small mb-2"
  }, [_vm._v(" Klik baris untuk memilih aset yang akan ditempatkan. ")]), !_vm.hasPengadaanSelected ? _c('div', {
    staticClass: "text-center text-muted py-4"
  }, [_vm._v(" Pilih no. pengadaan terlebih dahulu. ")]) : !_vm.assets.length ? _c('div', {
    staticClass: "text-center text-muted py-4"
  }, [_vm._v(" Tidak ada aset pada pengadaan ini. ")]) : _c('div', {
    staticClass: "barang-pick-list"
  }, _vm._l(_vm.assets, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "barang-pick-item",
      class: {
        'is-selected': _vm.isBarangSelected(item)
      },
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "click": function click($event) {
          return _vm.selectBarang(item);
        },
        "keydown": function keydown($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.selectBarang(item);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex align-items-start justify-content-between"
    }, [_c('div', {
      staticClass: "pr-1"
    }, [_c('div', {
      staticClass: "barang-pick-name"
    }, [_vm._v(" " + _vm._s(item.asset ? item.asset.nama : "-") + " ")]), _c('div', {
      staticClass: "text-muted small mb-50"
    }, [_vm._v(" " + _vm._s(item.asset && item.asset.satuan ? item.asset.satuan.satuan : "-") + " ")]), _c('div', {
      staticClass: "barang-pick-sisa",
      class: {
        'is-empty': _vm.assetSisa(item) <= 0
      }
    }, [_vm._v(" Sisa: " + _vm._s(_vm.assetSisa(item)) + " " + _vm._s(item.asset && item.asset.satuan ? item.asset.satuan.satuan : "") + " ")])]), _vm.isBarangSelected(item) ? _c('feather-icon', {
      staticClass: "barang-pick-check flex-shrink-0",
      attrs: {
        "icon": "CheckCircleIcon",
        "size": "22"
      }
    }) : _vm._e()], 1)]);
  }), 0)])], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-card', [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Form penempatan")]), _c('p', {
    staticClass: "text-muted small mb-2"
  }, [_vm.selectedBarang && _vm.selectedBarang.asset ? [_vm._v(" Aset dipilih: "), _c('strong', [_vm._v(_vm._s(_vm.selectedBarang.asset.nama))]), _vm._v(" — sisa "), _c('strong', [_vm._v(_vm._s(_vm.assetSisa(_vm.selectedBarang)))]), _vm._v(" " + _vm._s(_vm.selectedBarang.asset.satuan ? _vm.selectedBarang.asset.satuan.satuan : "") + " ")] : [_vm._v(" Pilih aset di kiri sebelum mengisi lokasi. ")]], 2), _c('fieldset', {
    attrs: {
      "disabled": !_vm.selectedBarang
    }
  }, [_vm.myGudang ? _c('b-form-group', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Pilih Gudang")]), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm.myGudang.nama_gudang
    }
  })], 1) : _vm._e(), _c('b-form-group', [_c('validation-provider', {
    attrs: {
      "name": "blok",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('label', {
          attrs: {
            "for": ""
          }
        }, [_vm._v("Pilih Lokasi Aset "), _c('span', {
          staticClass: "text-danger"
        }, [_vm._v("*")])]), _c('div', {
          staticClass: "d-flex align-items-start"
        }, [_c('v-select', {
          staticClass: "flex-grow-1",
          attrs: {
            "options": _vm.bloks,
            "required": !_vm.form.blok_id,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "placeholder": "Pilih lokasi"
          },
          model: {
            value: _vm.form.blok_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "blok_id", $$v);
            },
            expression: "form.blok_id"
          }
        }), _c('b-button', {
          staticClass: "ml-1 flex-shrink-0",
          attrs: {
            "variant": "outline-primary",
            "title": "Tambah lokasi aset"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openLokasiModal($event);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "PlusIcon"
          }
        })], 1)], 1), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Jumlah",
      "label-for": "nilai"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nilai",
      "type": "number",
      "disabled": "",
      "placeholder": "jumlah"
    },
    model: {
      value: _vm.form.jumlah,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "jumlah", $$v);
      },
      expression: "form.jumlah"
    }
  })], 1), _c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addBarang($event);
      }
    }
  }, [_vm._v(" Tambah ke antrian ")])], 1)], 1)])], 1), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-2"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Antrian penempatan")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.addedItems.length) + " item siap disimpan ")])]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.addedItems.length
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_vm._v(" Simpan penempatan ")])], 1), !_vm.addedItems.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada aset di antrian. Isi form lalu klik "), _c('strong', [_vm._v("Tambah ke antrian")]), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "fields": _vm.fieldsAddedItems,
      "bordered": "",
      "striped": "",
      "responsive": "",
      "items": _vm.addedItems
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(row.index + 1) + " ")];
      }
    }, {
      key: "cell(lokasi)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('strong', [_vm._v(_vm._s(item.lokasi))])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(row) {
        return [_c('b-link', {
          staticClass: "text-danger",
          attrs: {
            "title": "Hapus dari antrian"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.addedItems.splice(row.index, 1);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "size": "24",
            "icon": "XCircleIcon"
          }
        })], 1)];
      }
    }])
  })], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-tambah-lokasi-aset",
      "title": "Tambah Lokasi Aset",
      "centered": "",
      "ok-title": "Simpan",
      "cancel-title": "Batal"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.submitLokasi($event);
      }
    },
    model: {
      value: _vm.showLokasiModal,
      callback: function callback($$v) {
        _vm.showLokasiModal = $$v;
      },
      expression: "showLokasiModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Gudang Aset"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm.myGudang ? _vm.myGudang.nama_gudang : ''
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Nama Lokasi / Blok"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nama lokasi"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.submitLokasi($event);
      }
    },
    model: {
      value: _vm.lokasiForm.blok,
      callback: function callback($$v) {
        _vm.$set(_vm.lokasiForm, "blok", $$v);
      },
      expression: "lokasiForm.blok"
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }